import React, { useEffect, useState } from "react";
import ContentSectionEditor from "./components/ContentSectionEditor";

const EditorView = ({ label, value }) => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (value) {
      if (Array.isArray(value)) {
        setSections(value);
      } else if (typeof value === "string") {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            setSections(parsed);
          }
        } catch (e) {
          console.error("Invalid JSON format for EditorView content:", e);
        }
      }
    }
  }, [value]);

  return (
    <div className="w-full space-y-4 my-4">
      {label && (
        <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider">
          {label}
        </h3>
      )}

      <div className="space-y-6">
        {sections.length > 0 ? (
          sections.map((section) => (
            <div key={section.id || crypto.randomUUID()}>
              <ContentSectionEditor
                section={section}
                read={true}
                onUpdate={() => {}}
              />
            </div>
          ))
        ) : (
          <p className="text-sm text-slate-400 italic">No content available.</p>
        )}
      </div>
    </div>
  );
};

export default EditorView;
